module.exports = __webpack_public_path__ + "static/img/jet.57b45aa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logos/jet.svg
// module id = 705
// module chunks = 2 3 4 5 41 43 45